<template>
  <div id="Test-Report-Form" class="hbn-container">
    <div class="page-title">工伤认定统计</div>
    <div class="search-form">
      <el-form ref="form" :model="form" label-width="40px" label-position="top">
        <el-row :gutter="24">

          <el-col :span="18">
            <el-form-item label="自定义查询" style="width:400px">
              <el-date-picker
                v-model="searchform.dataRange"
                type="monthrange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="large"
                :shortcuts="shortcuts"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-button size="mini" class="hbn-button-serach" @click="GetData"
                >查找</el-button
              >
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="hbn-content">
      <div class="tbas" style="padding-bottom:10px">
        <el-tabs v-model="activeName" @tab-click=showPage2>
          <el-tab-pane label="第一页签" name="1"></el-tab-pane>
          <el-tab-pane label="第二页签" name="2" ></el-tab-pane>
        </el-tabs>
      </div>
      <div class="tab-item" v-show="activeName == 1">
        <div class="screen-item" >

          <div id="line-Chart" :style="{ width: '100%', height: '400px' }" ></div>
        </div>
        <div class="flex-layer">
          <div class="screen-item" >

            <div id="bar-Chart" :style="{ width: '100%', height: '400px' }" ></div>
          </div>
          <div class="screen-item">

            <div id="pie-Chart" :style="{ width: '100%', height: '400px' }" ></div>
          </div>
        </div>
      </div>
      <div class="tab-item" v-if="activeName == 2">
        <el-select v-model="SelectValue" placeholder="Select" @change="chageOpts">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-button type="primary" size="mini" class="custom-button" @click="export2Excel" style="margin-left:1rem;margin-bottom:.5rem;">
            <span>导出数据</span>
        </el-button>

        <vxe-table
          :data="Page2TableDataList"
          round
          border
          height="388"
          class="mytable-scrollbar"
          style="width: 100%"
          :highlight-current-row="true"
          ref="multipleTable"
          highlight-hover-row
          highlight-hover-column
          highlight-current-column
          show-overflow="tooltip"
          empty-text="没有更多数据了！"
          resizable
          stripe
          >
            <vxe-table-column
              v-for="(item, key) in Page2TableHeader"
              :key="key"
              :field="item.prop"
              :title="item.label"
              :width="item.width"
              align="center"
              show-overflow-tooltip
            />
        </vxe-table>
      </div>
    </div>
  </div>
</template>
<script>
  import { ElMessage } from 'element-plus'
  import { SelectTJ,SelectTJByYear,SelectTJByHY,SelectTJBySSBW } from "@api/ApiInjuryAffirmBill"
  import {Chart} from 'highcharts-vue'

  import Highcharts from "highcharts/highstock";
  import HighchartsMore from "highcharts/highcharts-more";
  import HighchartsDrilldown from "highcharts/modules/drilldown";
  import Highcharts3D from "highcharts/highcharts-3d";
  import HighchartsNoData from 'highcharts-no-data-to-display';
  import loadExporting from "highcharts/modules/exporting";
  import excel from '@comp/ExcelHelper/importExcel'
  import  Enumerable  from 'linq'

  HighchartsMore(Highcharts);
  HighchartsDrilldown(Highcharts);
  Highcharts3D(Highcharts);
  loadExporting(Highcharts);
  HighchartsNoData(Highcharts)

export default {
  name: 'injuryIdentificationStatistics',
  data() {
    return {
      options: [
        {
          value: 1,
          label: '折线图',
        },
        {
          value: 2,
          label: '柱状图',
        },
        {
          value: 3,
          label: '饼图',
        }
      ],
      shortcuts: [
        {
          text: '本月',
          value: [
            new Date(new Date().getFullYear(), new Date().getMonth(), 1),
            new Date(new Date().getFullYear(), new Date().getMonth()+1, 1)
          ],
        },
        {
          text: '本年',
          value: () => {
            const end = new Date()
            const start = new Date(new Date().getFullYear(), 0)
            return [start, end]
          },
        },
        {
          text: '半年',
          value: () => {
            const end = new Date()
            const start = new Date()
            start.setMonth(start.getMonth() - 6)
            return [start, end]
          },
        },
      ],
      SelectValue: 1,
      columns:[{
        title: '日期',
        dataIndex: 'SQTIME',
        width: 150,
      },
      {
        title: '工伤人数',
        dataIndex: 'SL',
      }],
      searchform: {
        name: '666',
        dataRange: '',
      },
      activeName: '1',
      tableData: [
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
        },
      ],
      DataList:[],
      LineDataList:[],
      PieDataList:[],//饼图 行业
      BarDataList:[],//柱状图 所属部位
      Page2TableDataList:[],
      lang:{
          noData:"没有更多数据了！",
          viewFullscreen:"全屏查看",
          printChart:"打印",
          downloadJPEG: "下载JPEG 图片",
          downloadPDF: "下载PDF文档",
          downloadPNG: "下载PNG 图片",
          downloadSVG: "下载SVG 矢量图",
          exportButtonTitle: "导出图片",
      },
      colors:[
        "#4F94CD",
        "#8487E9",
        "#54CA71",
        "#49A1FF",
        "#59CB74",
        "#FCD44A",
        "#985FE5",
        "#F3657C",
        "#435288",
        "#84E0BE",
        "#EAA676",
        "#8085E9",
        "#058DC7",
        "#50B432",
        "#ED561B",
        "#24CBE5",
        "#64E572",
        "#FF9655",
        "#87CEEB",
        "#7EC0EE",
        "#79CDCD",
        "#7171C6",
        "#C1FFC1",
        "#7FFFD4",
      ],
      Page2TableHeader:[],
      line : [
        {prop:"year",label:"年",width:"150",isHide:"false"},
        {prop:"month1",label:"1月",width:"150",isHide:"false"},
        {prop:"month2",label:"2月",width:"150",isHide:"false"},
        {prop:"month3",label:"3月",width:"150",isHide:"false"},
        {prop:"month4",label:"4月",width:"150",isHide:"false"},
        {prop:"month5",label:"5月",width:"150",isHide:"false"},
        {prop:"month6",label:"6月",width:"150",isHide:"false"},
        {prop:"month7",label:"7月",width:"150",isHide:"false"},
        {prop:"month8",label:"8月",width:"150",isHide:"false"},
        {prop:"month9",label:"9月",width:"150",isHide:"false"},
        {prop:"month10",label:"10月",width:"150",isHide:"false"},
        {prop:"month11",label:"11月",width:"150",isHide:"false"},
        {prop:"month12",label:"12月",width:"150",isHide:"false"},
      ],
      bar:[
        {prop:"SHBU",label:"部位代码",width:"150",isHide:"false"},
        {prop:"SHBW",label:"部位名称",width:"150",isHide:"false"},
        {prop:"SL",label:"数量",width:"150",isHide:"false"},
      ],
      pie:[
        {prop:"SSHY",label:"行业代码",width:"150",isHide:"false"},
        {prop:"HYName",label:"行业名称",width:"150",isHide:"false"},
        {prop:"SL",label:"数量",width:"150",isHide:"false"},
      ],
      titleName:"折线图"
    }
  },
  components: {
    highcharts: Chart
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
        this.search()

    })
  },
  methods: {
    export2Excel  ()  {
        const v=this;
        require.ensure([], () => {
            const {
                export_json_to_excel
            } = require("@/excel/Export2Excel.js"); //必须使用绝对路径

            const tHeader = [...Enumerable.from(v.Page2TableHeader).select((item) => {
                return item.label
            }).toArray()]; // 标题
            const filterVal = [...Enumerable.from(v.Page2TableHeader).select((item) => {
                return item.prop
            }).toArray()]; // 导出的字段名
            const list = v.Page2TableDataList;
            const data = v.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, `工伤认定统计-`+v.titleName);

        });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    chageOpts(val){

      // val 1 折线图 2 柱状图 3 饼图
      this.Page2TableDataList=[];
      if(val==1){
        const v=this;
        this.LineDataList.forEach(e=>{
          var obj={}
          obj.year=e.Year
          e.Data.forEach(y=>{
            obj["month"+y.Month+""]=y.SL
          });
          v.Page2TableDataList.push(obj);
        });
        // console.log(this.Page2TableDataList)
      }else{
        this.Page2TableDataList= val==2? this.BarDataList:val==3? this.PieDataList:[]
      }
      this.Page2TableHeader= val==1? this.line:val==2? this.bar:val==3? this.pie:[]
      this.titleName=this.options.find(x=>x.value==val).label//val==1? "折线图":val==2? "柱状图":val==3? "饼图":"折线图"
    },
    showPage2(){
      if(this.activeName==2)this.chageOpts(this.SelectValue);
    },
    /**
     * 折线图
     */
    lineChart() {
      //const categories=[];
      const seriesData=[];
      this.LineDataList.forEach(e=>{
        const data=[];
        e.Data.forEach(y=>{
          // if(y.SL==0){
          //   data.push(null)
          // }
          // else {
            data.push(y.SL)
          // }
        })

        seriesData.push({
            name: e.Year+'年工伤人数',
            // color: '#2d8cf0',
            data: data,
            lineWidth: 3, // 线宽
            cursor: 'pointer', // 鼠标样式
            dashStyle: 'Solid' // 线条样式
        });
      });


      // 初始化 Highcharts 图表

      new Highcharts.Chart("line-Chart", {
        credits: {
          enabled: false // 禁用版权信息
        },
        exporting: {
			    filename: '铁安通工伤预防智能帮手-折线图'
		    },
        title: {
          text: "折线图",
        },
        subtitle: {
          text: "数据来源:铁安通工伤预防智能帮手",
        },
        colors:this.colors,
        lang: this.lang,
        // X轴
        xAxis: {
            title: {
                text: '月'
            },
            // 数据项
            categories: [1,2,3,4,5,6,7,8,9,10,11,12]
        },
        // Y轴
        yAxis: {
          title: {
            align: "high",
            textAlign: "left",
            rotation: 0,
            offset: 0,
            margin: 0,
            y: -20,
            x: -15,
            text: "工伤人数",
          },
        },
        legend: {
          layout: "vertical",
          align: "right",
          verticalAlign: "middle",
        },
        plotOptions: {
          series: {
          label: {
            connectorAllowed: false
          },
          marker: {
                radius: 1, // 大小
                enabled: true,  // 为true时，自定义显示 下方label无效
                states: {
                    // 状态
                    hover: {
                        radius: 2,
                        lineWidthPlus: 1
                    }
                }
            },
          },
        },
        responsive: {
          rules: [{
            condition: {
              maxWidth: 500
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                align: 'center',
                verticalAlign: 'bottom'
              }
            }
          }]
        },
        series:seriesData
      });
    },
    /**
     * 柱状图
     */
    barChart(){
      const categories=[];
      const seriesData=[];
      this.BarDataList.forEach(e=>{
        categories.push(e.SHBW);
        seriesData.push(e.SL);
      });

      // 初始化 Highcharts 图表
      new Highcharts.Chart("bar-Chart", {
        credits: {
          enabled: false // 禁用版权信息
        },
        exporting: {
			    filename: '铁安通工伤预防智能帮手-柱状图'
		    },
        title: {
          text: "柱状图",
        },
        chart: {
              type: 'column'
        },
        subtitle: {
          text: "数据来源:铁安通工伤预防智能帮手",
        },
        lang: this.lang,
        // X轴
        xAxis: {
            // 数据项
            categories: categories
        },
        // Y轴
        yAxis: {
          title: {
            align: "high",
            textAlign: "left",
            rotation: 0,
            offset: 0,
            margin: 0,
            y: -20,
            x: -15,
            text: "工伤人数",
          },
          // 标示线
          plotLines: [{
            value: 0,
            width: 1,
            color: '#808080'
          }]
        },
        colors:this.colors,
        tooltip: {
          valueSuffix: '人' // 提示信息所带单位
        },
        legend: {
          enabled: false //  禁用图例
        },
        plotOptions: {
          series: {
            marker: {
                radius: 1, // 大小
                enabled: true,  // 为true时，自定义显示 下方label无效
                states: {
                    // 状态
                    hover: {
                        radius: 2,
                        lineWidthPlus: 1
                    }
                }
            },
          },
        },
        series:[{
            name: '工伤人数',
            data: seriesData,//[12, 34, 23, 35, 47, 32, 12, 19],
        }],
      })
    },
    /**
     * 饼图
     */
    pieChart(){
      const seriesData=[];
      this.PieDataList.forEach(e=>{
        seriesData.push([e.HYName,e.SL]);
      });

      // 初始化 Highcharts 图表
      new Highcharts.Chart("pie-Chart", {
        chart: {
            type: 'pie',//饼图
              options3d: {
                  enabled: true,//使用3d功能
                  alpha: 60,//延y轴向内的倾斜角度
                  beta: 0,
              }
        },
        credits: {
          enabled: false // 禁用版权信息
        },
        exporting: {
			    filename: '铁安通工伤预防智能帮手-饼图'
		    },
        title: {
          text: "饼图",
        },
        subtitle: {
          text: "数据来源:铁安通工伤预防智能帮手",
        },
        lang: this.lang,
        colors:this.colors,
        plotOptions: {
            pie: {
                allowPointSelect: true,//每个扇块能否选中
                cursor: 'pointer',//鼠标指针
                depth: 35,//饼图的厚度
                dataLabels: {
                    enabled: true,//是否显示饼图的线形tip
                }
            }
        },
        series:[{
            type: 'pie',
            name: '工伤人数',
            data: seriesData,
        }]
      });
    },
    search(){
      this.Page2TableDataList=[];
      this.SelectTJ();
      this.activeName="1";
    },
    SelectTJ(){

      const obj={};
      const v=this;
      if(this.searchform.dataRange&&this.searchform.dataRange.length>0){
        obj.StartTime=this.searchform.dataRange[0];
        obj.EndTime=this.searchform.dataRange[1];
      }

      SelectTJByYear(JSON.stringify(obj)).then(function(data){
        if(data.status==200){
          v.LineDataList=data.data;

          v.lineChart();

        }else{
           ElMessage.error('error!')
        }
      });
      SelectTJByHY(JSON.stringify(obj)).then(function(data){
        if(data.status==200){
          v.PieDataList=data.data;

          v.pieChart()
        }else{
           ElMessage.error('error!')
        }
      });
      SelectTJBySSBW(JSON.stringify(obj)).then(function(data){
        if(data.status==200){
          v.BarDataList=data.data;
          v.barChart()
        }else{
           ElMessage.error('error!')
        }
      });
    },
    setLineChart() {
      let myChart = this.$echarts.init(document.getElementById('line-Chart'))
      myChart.setOption({
        grid: {
          x: 50,
          y: 30,
          x2: 25,
          y2: 65,
          borderWidth: 1,
        },
        tooltip: {},
        splitLine: {
          show: true,
          lineStyle: {
            color: ['#E9DFDF'],
            width: 1,
            type: 'solid',
          },
        },
        xAxis: {
          data: ['12-3', '12-4', '12-5', '12-6', '12-7', '12-8'],
          axisLine: {
            lineStyle: {
              color: '#8C8C8C',
              width: 1, //这里是为了突出显示加上的
            },
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#8C8C8C',
            },
          },
        },
        yAxis: {
          splitLine: {
            //网格线
            lineStyle: {
              type: 'dashed', //设置网格线类型 dotted：虚线   solid:实线
            },
            show: true, //隐藏或显示
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#8C8C8C',
            },
          },
        },
        series: [
          {
            name: '用户量',
            type: 'line',
            data: [5, 20, 36, 10, 10, 20],
            lineStyle: {
              color: '#5EC6B5', //改变折线颜色
            },
            symbolSize: 8,
            itemStyle: {
              normal: {
                color: '#5EC6B5',
                lineStyle: {
                  width: 2,
                },
              },
            },
          },
        ],
      })
    },
    setBarChart() {
      let myChart = this.$echarts.init(document.getElementById('bar-Chart'))
      myChart.setOption({
        grid: {
          x: 50,
          y: 30,
          x2: 25,
          y2: 65,
          borderWidth: 1,
        },
        tooltip: {},
        splitLine: {
          show: true,
          lineStyle: {
            color: ['#E9DFDF'],
            width: 1,
            type: 'solid',
          },
        },
        xAxis: {
          data: ['12-3', '12-4', '12-5', '12-6', '12-7', '12-8'],
          axisLine: {
            lineStyle: {
              color: '#8C8C8C',
              width: 1, //这里是为了突出显示加上的
            },
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#8C8C8C',
            },
          },
        },
        yAxis: {
          splitLine: {
            //网格线
            lineStyle: {
              type: 'dashed', //设置网格线类型 dotted：虚线   solid:实线
            },
            show: true, //隐藏或显示
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#8C8C8C',
            },
          },
        },
        series: [
          {
            name: '用户量',
            type: 'bar',
            data: [5, 20, 36, 10, 10, 20],
            symbolSize: 8,
            barWidth: 30,
            itemStyle: {
              normal: {
                color: '#1D6DE4',
                lineStyle: {
                  width: 2,
                },
              },
            },
          },
        ],
      })
    },
    setPieChart() {
      let myChart = this.$echarts.init(document.getElementById('pie-Chart'))
      myChart.setOption({
        tooltip: {
          trigger: 'item',
        },
        legend: {
          orient: 'vertical',
          right: 50,
          top: 'center',
        },
        color: ['#3BA0FF', '#FAD337', '#975FE4', '#F2637B'],
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: ['30%', '50%'],
            center: ['35%', '53%'],
            data: [
              { value: 1048, name: 'Search Engine' },
              { value: 735, name: 'Direct' },
              { value: 580, name: 'Email' },
              { value: 484, name: 'Union Ads' },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
            itemStyle: {
              normal: {
                borderColor: '#FFFFFF',
                borderWidth: 1,
                label: {
                  show: false,
                  formatter: '{d}%',
                },
                labelLine: {
                  show: false,
                },
              },
            },
          },
        ],
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/common/css/Hbn_modules/reset-input';
</style>
<style lang='scss' scoped>
@import '../../common/css/Hbn_modules/hbn-base-model';
.hbn-content {

  .screen-item {
    border-radius: 2px 2px 2px 2px;
    opacity: 1;
    border: 1px solid #d8dee8;
    position: relative;
    margin-bottom: 26px;
  }

  .custom-chart-title {
    height: 58px;
    padding: 0 15px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgba(216, 222, 232, 1);

    .chart-name {
      font-size: 16px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #33404e;
    }

    .hbn-load {
      width: 73px;
      max-height: 32px;
      min-height: 32px;
      background: #0747a6;
      border-radius: 2px 2px 2px 2px;
      font-size: 14px;
      font-family: Roboto-Regular, Roboto;
      font-weight: 400;
      color: #ffffff;
      line-height: 32px;
      padding: 0;
      border: 0;

      .el-icon-download {
        font-size: 18px;
      }
    }
  }
  .flex-layer {
    display: flex;
    justify-content: space-between;
    .screen-item {
      width: calc(50% - 11px);
      .pie-custom-title {
        position: absolute;
        top: 68px;
        width: 100%;
        .text {
          text-align: center;
          font-weight: 500;
        }
        .name {
          font-size: 14px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #8c8c8c;
          line-height: 22px;
          margin-bottom: 14px;
        }
        .sub {
          .pie-unit {
            font-size: 14px;
            font-family: Roboto-Regular, Roboto;
            font-weight: 400;
            color: #404c59;
            line-height: 22px;
          }
          .num {
            font-size: 32px;
            font-family: Roboto-Regular, Roboto;
            font-weight: 400;
            color: #404c59;
            line-height: 22px;
          }
        }
      }
    }
  }
  .hbn-pagination-layer {
    display: flex;
    padding-top: 20px;
    justify-content: flex-end;
  }
}
</style>

<style scoped>
.search-form{
  padding: 10px 0;
}

.search-form /deep/ .is-guttered{
  display: flex;
  align-items: center;
  white-space: nowrap;
}
.custom-table-header > th {
  background: #dfdfdf !important;
}
.custom-table-header > th > .cell {
  font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
  font-weight: 500;
  color: #868686 !important;
  line-height: 22px;
}
.hbn-content /deep/ .el-table .cell {
  color: #32383d;
}
</style>